import styles from './template.css';
import {AoflElement, customElement} from '@aofl/element';
import {html, templateCaches} from 'lit-html';
import {routerInstance} from '@aofl/router';
import CDIV from '../cdiv-component';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';
import '../layout-sdo';
import '@modules/support-widget';
import * as Sentry from '@sentry/browser';

/**
 *
 * @class RouteViewElement
 * @extends {AoflElement}
 */
@customElement('route-view')
class RouteViewElement extends AoflElement {
  /**
   *
   * Creates an instance of RouteViewElement.
   */
  constructor() {
    super();
    this.template = () => {};
    routerInstance.after(async (request, response, next) => {
      templateCaches.delete('html--' + RouteViewElement.is);
      try {
        if (response.matchedRoute === null) {
          throw new Error('Route Not Found');
        }
        const component = (await response.matchedRoute.resolve()).default;
        this.updateTemplate(response.matchedRoute.title, component.is);
      } catch (e) {
        Sentry.captureException(e);
        this.updateTemplate('404 - Not Found', CDIV.is);
      } finally {
        this.setLoaded();
        storeInstance.commit(
          {
            namespace: sdoNs.SIMPLE_MODAL,
            mutationId: 'hideModals'
          },
          {
            namespace: sdoNs.DROPDOWN,
            mutationId: 'closeAll'
          });
        next(response);
      }
    });
  }

  /**
   *
   *
   * @readonly
   */
  static is = 'route-view';

  first = true;
  setLoaded() {
    if (this.first && typeof aofljsConfig.__prerender__ === 'undefined') {
      this.classList.add('loaded');
      document.body.classList.add('loaded');
      window.dispatchEvent(new CustomEvent('resize'));
    }
    this.first = false;
  }

  /**
   *
   * @private
   * @param {String} title
   * @param {String} tag
   */
  updateTemplate(title, tag) {
    document.title = title;
    const t = `<${tag} class="flex-grow-1"></${tag}><site-footer></site-footer><support-widget></support-widget>`;
    this.template = () => html([t]);
    this.requestUpdate();
  }
  connectedCallback() {
    super.connectedCallback();

    while (this.firstChild) {
      this.removeChild(this.firstChild);
    }
  }
  /**
   *
   * @return {Object}
   * @memberof RouteViewElement
   */
  render() {
    return super.render(this.template, [styles]);
  }
}

export default RouteViewElement;
